import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/render/project/src/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/opt/render/project/src/src/components/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/render/project/src/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/render/project/src/src/context/ThemeContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/styles/tailwind.css");
